import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/settings/rule-set/create/$ruleIndex')({
  beforeLoad: () => getTitleContextSlice('Rule Index'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
